import {
  PublicBidStatus,
  type PublicBidDto,
} from "../../../../autogen/bff-api";

export const isPublicBidEditable = (
  bid: Pick<PublicBidDto, "status" | "signedDocumentId">,
): boolean => bid.status === PublicBidStatus.Draft && !bid.signedDocumentId;
